export { default as default } from './KitFadeView';
